import axios from 'axios';
import { API_BASE_URL } from '../../config';

const authApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't clear token here — let checkAuthStatus handle the redirect
      // Only clear on explicit logout or failed token validation
    }
    return Promise.reject(error);
  }
);

const authService = {
  register: (userData) => {
    return authApi.post('/users/register', userData);
  },

  login: (credentials) => {
    return authApi.post('/users/login', credentials);
  },

  getProfile: () => {
    return api.get('/users/profile');
  },

  updateProfile: (userData) => {
    return api.put('/users/profile', userData);
  },

  changePassword: (passwordData) => {
    return api.post('/users/change-password', passwordData);
  },

  requestPasswordReset: (email) => {
    return authApi.post('/users/forgot-password', { email });
  },

  resetPassword: (resetData) => {
    return authApi.post('/users/reset-password', resetData);
  },

  logout: () => {
    localStorage.removeItem('token');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};

export default authService;
